import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsVPPAdminVisitorLogListParm } from "./wsVPPAdminVisitorLogListParm";
import { wsVPPAdminVisitorLogPrintDataParm } from "./wsVPPAdminVisitorLogPrintDataParm";
import * as moment from "moment";

@Injectable()
export class DataService_viewlog {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	FacilityByUserIDSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	FacilityByUserIDSelectList(UserID: number) {
		var postResult$ = new Subject();
		var url = "Visitor/FacilityByUserIDSelectList";

		var promise$ = this.httpclientService.post(url, UserID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorLogSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorLogSelectList(parms: wsVPPAdminVisitorLogListParm) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminVisitorLogSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorLogPrintDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorLogPrintDataGet(parms: wsVPPAdminVisitorLogPrintDataParm) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminVisitorLogPrintDataGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Print
	//
	//-----------------------------------------------------------------------------------------------------
	Print_RPTVisitorLog(VisitorLogStatusID: number, StartDate: Date, EndDate: Date, FacilityID: number, SortByCD: string, isASC: boolean, UserID: number) {
		var strSortDirection: string = "";
		var strStartDate: string = (strStartDate = moment(StartDate).format("MM/DD/YYYY") + " 00:00:00 AM");
		var strEndDate: string = (strEndDate = moment(EndDate).format("MM/DD/YYYY") + " 00:00:00 AM");

		if (FacilityID < 0) {
			FacilityID = 0;
		}

		if (isASC == true) {
			strSortDirection = "Ascending";
		} else {
			strSortDirection = "Descending";
		}

		//
		//	Build strParam
		//
		var strParam: string =
			VisitorLogStatusID.toString() +
			"|" +
			"VisitorLogStatusID," +
			strStartDate +
			"|" +
			"StartDate," +
			strEndDate +
			"|" +
			"EndDate," +
			FacilityID.toString() +
			"|" +
			"FacilityID," +
			SortByCD +
			"|" +
			"SortBy," +
			strSortDirection +
			"|" +
			"SortDirection," +
			UserID.toString() +
			"|" +
			"UserID";

		var reportFileName = "RPTVisitorLog.rpx";
		var strSchoolID: string = "-1";

		//
		//	Generate PDF
		//
		var postResult$ = new Subject();
		var url = "Report/PrintByReportFileName?ReportFileName=" + reportFileName + "&strParam=" + strParam + "&schoolID=" + strSchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.next(error);
			}
		);

		return postResult$;
	}
}
